import React from "react";
import { useNavigate } from "react-router";
import { HiArrowLeft } from "react-icons/hi";

type Props = {
  title: string;
};

const ParkingHeader = (props: Props) => {
  const navigate = useNavigate();
  return (
    <div className="text-[#434343] font-medium lg:text-[32px] text-[26px]  flex flex-row justify-center">
      <p
        className="w-[40%] mt-[5px] cursor-pointer"
        onClick={() => {
          navigate("/profile/vehicle");
          onclick = () => {};
        }}
      >
        <HiArrowLeft></HiArrowLeft>
      </p>
      <p className="w-[60%]">{props.title}</p>
    </div>
  );
};
export default ParkingHeader;
